application.register("lib-tabs", class extends Stimulus.Controller {
    connect() {
        this._tabs = this.targets.findAll('tab')
        this._tabPanels = this.targets.findAll('tabPanel')
    }
    toggle ({ currentTarget }) {
        if(arguments[0].type === 'keydown' && (arguments[0].key !== 'Enter' && arguments[0].key !== ' ')) {
            return
        }

        arguments[0].preventDefault()
        arguments[0].stopPropagation()

        if(currentTarget.ariaSelected === 'true') return

        if (this._tabs.length) {
            this._tabs.forEach(tab => (tab.ariaSelected = 'false'))

            currentTarget.ariaSelected = 'true'
        }

        if (this._tabPanels.length) {
            this._tabPanels.forEach(panel => (panel.ariaHidden = 'true'))

            const ariaControls = this.element.querySelector(`[id=${currentTarget.getAttribute('aria-controls')}]`)

            if (ariaControls) {
                setTimeout(() => {
                    ariaControls.ariaHidden = 'false'
                },300)
            }
        }
    }
})
